<script setup lang="ts">
const { supplierName } = defineProps<{
  supplierName: string
}>()

interface BillingLetterStep {
  key: string
  before?: string
  bold: string
  after?: string
  emphasis?: boolean
}

const { t } = useI18n()

const steps = computed<BillingLetterStep[]>(() => [
  {
    key: 'contact',
    before: t('receipt-model.billing_letter.next_steps.contact_before'),
    bold: supplierName,
    after: t('receipt-model.billing_letter.next_steps.contact_after'),
    emphasis: true,
  },
  {
    key: 'informed',
    before: t('receipt-model.billing_letter.next_steps.informed_before'),
    bold: t('receipt-model.billing_letter.next_steps.informed_bold'),
    after: t('receipt-model.billing_letter.next_steps.informed_after'),
  },
  {
    key: 'request',
    before: t('receipt-model.billing_letter.next_steps.request_before'),
    bold: t('receipt-model.billing_letter.next_steps.request_bold'),
    after: t('receipt-model.billing_letter.next_steps.request_after'),
  },
  {
    key: 'attach',
    bold: t('receipt-model.billing_letter.next_steps.attach_bold'),
    after: t('receipt-model.billing_letter.next_steps.attach_after'),
  },
])
</script>

<template>
  <div class="billing-letter-next-steps" data-testid="billing-letter-next-steps">
    <h5 class="fonts-heading-h4 text-neutral-low-dark">
      {{ t('receipt-model.billing_letter.next_steps.title') }}
    </h5>
    <ul class="billing-letter-next-steps__list">
      <li
        v-for="step in steps"
        :key="step.key"
        class="billing-letter-next-steps__item"
      >
        {{ step.before }}<strong class="font-bold" :class="{ 'text-neutral-low-medium': step.emphasis }">{{ step.bold }}</strong>{{ step.after }}
      </li>
    </ul>
  </div>
</template>

<style lang="scss" scoped>
.billing-letter-next-steps {
  @apply flex flex-col gap-micro px-4xs py-micro;
  @apply rounded-md border-a-xs border-brand-primary-light bg-brand-secondary-light;

  &__list {
    @apply flex flex-col gap-nano m-0 pl-[18px] list-disc;
  }

  &__item {
    @apply fonts-body-medium-regular text-neutral-low-light;

    line-height: theme('lineHeight.lg');
  }
}
</style>
